<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 * 
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *            佛祖保佑     永不宕机     永无BUG
 * 
 *        佛曰:  
 *                写字楼里写字间，写字间里程序员；  
 *                程序人员写程序，又拿程序换酒钱。  
 *                酒醒只在网上坐，酒醉还来网下眠；  
 *                酒醉酒醒日复日，网上网下年复年。  
 *                但愿老死电脑间，不愿鞠躬老板前；  
 *                奔驰宝马贵者趣，公交自行程序员。  
 *                别人笑我忒疯癫，我笑自己命太贱；  
 *                不见满街漂亮妹，哪个归得程序员？
 * 
 * @Author: ZP
 * @Date: 2024-02-28 11:35:27
 * @FilePath: \project\Disassembly_mobile\src\views\DataSupplement\index.vue
 * @LastEditors: zp
 * @LastEditTime: 2024-03-04 17:25:44
 -->

<template>
  <div>
    <div class="header">
      <span @click="gouot"></span>
      <span>车辆信息</span>
      <span @click="islogout">退出</span>
    </div>
    <div class="content">
      <van-tabs v-model="active" @click="onClick">
        <van-tab title="未完善"
          ><Imperfection ref="fectionRef1" type="1"
        /></van-tab>
        <van-tab title="已完善"
          ><Imperfection ref="fectionRef2" type="2"
        /></van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Imperfection from "./Imperfection.vue";
export default {
  components: {
    Imperfection,
  },
  data() {
    return {
      active: 0,
    };
  },
  mounted() {},
  methods: {
    gouot() {
      this.$router.push("/Recognition");
    },
    onClick(i) {
      this.$nextTick(() => {
        if (i == 0) this.$refs.fectionRef1.getId(i);
        if (i == 1) this.$refs.fectionRef2.getId(i);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  z-index: 9;
  width: calc(100% - 40px);
  padding: 0 20px;
  background-color: cadetblue;
  height: 1rem;
  line-height: 1rem;
  color: white;
  font-size: 0.4rem;
  display: flex;
  justify-content: space-between;
  span {
    display: inline-block;
  }
  span:nth-child(1) {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/u39.png);
    background-size: 100%;
    margin-top: 8px;
  }
}
.content {
  padding-top: 55px;
}
</style>
